import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=80c135d0&scoped=true&%40dialog-closed=%24emit('dialog-closed')&"
import script from "./Dialog.vue?vue&type=script&lang=ts&"
export * from "./Dialog.vue?vue&type=script&lang=ts&"
import style0 from "./Dialog.vue?vue&type=style&index=0&id=80c135d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c135d0",
  null
  
)

export default component.exports